import api from './api';

export const userAPI = {
  // Get appUsers with pagination and filters
  getUsers: async (params = {}) => {
    const token = localStorage.getItem('auth_token');
    const queryParams = {
      access_token: token,
      ...(params.page && { skip: (params.page - 1) * (params.limit || 25) }),
      ...(params.limit && { limit: params.limit }),
      ...(params.search && {
        filter: JSON.stringify({
          where: {
            or: [
              { firstname: { like: `%${params.search}%`, options: 'i' } },
              { lastname: { like: `%${params.search}%`, options: 'i' } },
              { email: { like: `%${params.search}%`, options: 'i' } }
            ]
          }
        })
      })
    };

    const response = await api.get('/api/appUsers', { params: queryParams });
    
    // Return in expected format
    return {
      users: response,
      total: response.length,
      page: params.page || 1,
      per_page: params.limit || 25
    };
  },

  // Get single appUser
  getUser: async (id) => {
    const token = localStorage.getItem('auth_token');
    const response = await api.get(`/api/appUsers/${id}?access_token=${token}`);
    return response;
  },

  // Create new appUser
  createUser: async (userData) => {
    const token = localStorage.getItem('auth_token');
    const response = await api.post('/api/appUsers', {
      ...userData,
      access_token: token
    });
    return response;
  },

  // Update appUser
  updateUser: async (id, userData) => {
    const token = localStorage.getItem('auth_token');
    const response = await api.put(`/api/appUsers/${id}?access_token=${token}`, userData);
    return response;
  },

  // Delete appUser
  deleteUser: async (id) => {
    const token = localStorage.getItem('auth_token');
    const response = await api.delete(`/api/appUsers/${id}?access_token=${token}`);
    return response;
  },

  // Get users from the 'users' model (different from appUsers)
  getSystemUsers: async (params = {}) => {
    const token = localStorage.getItem('auth_token');
    const queryParams = {
      access_token: token,
      ...(params.centers && {
        filter: JSON.stringify({
          where: {
            centers: { inq: params.centers }
          }
        })
      }),
      ...(params.role && {
        filter: JSON.stringify({
          where: {
            role: params.role
          }
        })
      })
    };

    const response = await api.get('/api/users', { params: queryParams });
    return response;
  },

  // Create system user
  createSystemUser: async (userData) => {
    const token = localStorage.getItem('auth_token');
    const response = await api.post('/api/users', {
      ...userData,
      access_token: token
    });
    return response;
  },

  // Get customers (for customer management)
  getCustomers: async (params = {}) => {
    const token = localStorage.getItem('auth_token');
    const queryParams = {
      access_token: token,
      ...(params.include && {
        filter: JSON.stringify({
          include: params.include // e.g., ['coordinates', 'moneycollections']
        })
      }),
      ...(params.type && {
        filter: JSON.stringify({
          where: {
            type: params.type
          }
        })
      })
    };

    const response = await api.get('/api/customers', { params: queryParams });
    return response;
  },

  // Create customer
  createCustomer: async (customerData) => {
    const token = localStorage.getItem('auth_token');
    const response = await api.post('/api/customers', {
      ...customerData,
      access_token: token
    });
    return response;
  },

  // Update customer
  updateCustomer: async (id, customerData) => {
    const token = localStorage.getItem('auth_token');
    const response = await api.put(`/api/customers/${id}?access_token=${token}`, customerData);
    return response;
  },

  // Delete customer
  deleteCustomer: async (id) => {
    const token = localStorage.getItem('auth_token');
    const response = await api.delete(`/api/customers/${id}?access_token=${token}`);
    return response;
  },

  // Get centers for user management
  getCenters: async () => {
    const token = localStorage.getItem('auth_token');
    const response = await api.get(`/api/centers?access_token=${token}`);
    return response;
  },

  // Bulk operations for appUsers
  bulkDelete: async (userIds) => {
    const token = localStorage.getItem('auth_token');
    const deletePromises = userIds.map(id => 
      api.delete(`/api/appUsers/${id}?access_token=${token}`)
    );
    
    const results = await Promise.allSettled(deletePromises);
    return {
      success: results.filter(r => r.status === 'fulfilled').length,
      failed: results.filter(r => r.status === 'rejected').length
    };
  },
};